<template>
  <a
    href="https://getbiew.com/"
    class="biew-badge px-4 py-2 bg-gray-900 text-white font-light"
  >
    Made with
    <span class="font-bold">Biew</span>
  </a>
</template>

<script>
export default {
  name: "BiewBadge"
};
</script>

<style lang="scss" scoped>
.biew-badge {
  position: fixed;
  right: 1em;
  bottom: 1em;
  border-radius: 1em;
  box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.biew-badge:hover {
  bottom: 1.5em;
}
</style>
